import type { NavIconName } from "../nav";

/**
 * Task L: one consistent line-icon set for the sidebar (24×24 grid, 1.75 stroke, currentColor) instead of mixed
 * Unicode glyphs whose size and weight varied by font. Shapes follow the common "outline icon" vocabulary.
 */
const P: Record<NavIconName | "search" | "chevron", string> = {
  overview: "M3 3h7v9H3zM14 3h7v5h-7zM14 12h7v9h-7zM3 16h7v5H3z",
  repeat: "M17 2l4 4-4 4M3 11V9a3 3 0 0 1 3-3h15M7 22l-4-4 4-4M21 13v2a3 3 0 0 1-3 3H3",
  whatsapp: "M3 21l1.6-4.6A8.5 8.5 0 1 1 7.7 19.6zM9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.6-2-1-1 .9c-1.2-.5-2.3-1.6-2.8-2.8l.9-1-1-2z",
  calendar: "M4 5h16v16H4zM4 10h16M8 3v4M16 3v4M8 14h2M14 14h2M8 17h2",
  register: "M3 6h18v12H3zM3 10h18M7 15h3",
  orders: "M5 8h14l-1 13H6zM9 8V6a3 3 0 0 1 6 0v2M9 14l3 3 3-3M12 10v7",
  approvals: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM8 12l3 3 5-6",
  customers: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21v-1a6 6 0 0 1 12 0v1M16 3.5a4 4 0 0 1 0 7M18 14a5 5 0 0 1 4 5v2",
  membership: "M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.8 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8z",
  wallet: "M3 7h16a2 2 0 0 1 2 2v10H3zM3 7l13-4v4M16 13h2",
  campaigns: "M3 10v4h3l7 5V5L6 10zM17 9a4 4 0 0 1 0 6M20 6a8 8 0 0 1 0 12",
  services: "M6 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM6 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM8.5 7.5 20 19M8.5 16.5 20 5",
  ticket: "M3 7h18v3a2 2 0 0 0 0 4v3H3v-3a2 2 0 0 0 0-4zM14 7v10",
  receipt: "M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2zM9 8h6M9 12h6M9 16h3",
  team: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21v-1a8 8 0 0 1 16 0v1",
  payroll: "M2 6h20v12H2zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM6 9v.01M18 15v.01",
  box: "M3 7l9-4 9 4v10l-9 4-9-4zM3 7l9 4 9-4M12 11v10",
  clipboard: "M8 4h8v3H8zM6 5H4v16h16V5h-2M8 12h8M8 16h5",
  truck: "M2 6h12v10H2zM14 9h4l4 4v3h-8M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  payables: "M6 3h9l4 4v14H6zM15 3v4h4M12 10v7M10 12.5a2 1.5 0 0 1 4 0 2 1.5 0 0 1-4 2 2 1.5 0 0 0 4 0",
  dailyClose: "M4 5h16v16H4zM4 10h16M8 3v4M16 3v4M9 15l2 2 4-4",
  expenses: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v10M15 9.5c0-1.4-1.3-2-3-2s-3 .8-3 2 1.3 1.6 3 2 3 .9 3 2.2-1.3 2.3-3 2.3-3-.8-3-2",
  reports: "M4 20V10M10 20V4M16 20v-7M22 20H2",
  globe: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z",
  store: "M3 9l2-5h14l2 5zM3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0M5 12v9h14v-9M10 21v-5h4v5",
  settings: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 2v3M12 19v3M4.9 4.9 7 7M17 17l2.1 2.1M2 12h3M19 12h3M4.9 19.1 7 17M17 7l2.1-2.1",
  addons: "M4 4h16v16H4zM12 8v8M8 12h8",
  cash: "M3 8h18v11H3zM5 4h14v4M3 13h18M10 16h4",
  clock: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3 2",
  camera: "M4 8h3l2-3h6l2 3h3v11H4zM12 10.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z",
  chart: "M5 20V11M11 20V5M17 20v-6M3 20h18",
  home: "M3 11l9-7 9 7M5 9.5V21h5v-6h4v6h5V9.5",
  more: "M4 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0zM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0zM17 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0z",
  sun: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4",
  building: "M4 21V5l8-3v19M12 8h8v13M2 21h20M8 8v.01M8 12v.01M8 16v.01M16 12v.01M16 16v.01",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4-4",
  chevron: "M9 6l6 6-6 6",
};

export function NavIcon({ name, size = 18, className = "nav-icon" }: { name: NavIconName | "search" | "chevron"; size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false" data-icon={name}>
      <path d={P[name]} />
    </svg>
  );
}
